import React, { useState, useEffect, useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { ContextAPI } from "../../../ContextAPI";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Tabs,
  Row,
  Col,
  Card,
  Result,
  Divider,
  Table,
  Popconfirm,
  Form,
  Select,
} from "antd";
import moment from "moment";
import { platformApi } from "../../../api";
import MaterialIssueTable from "./MaterialIssueTable";
import AssignMechanic from "./RampCard/AssignMechanic";
import AssignJob from "./RampCard/AssignJob";
import { getUUID } from "../../../_helpers/utils";
import { useCallback } from 'react';
import { debounce } from 'lodash';

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

export default function MaterialIssues() {
  const history = useHistory();
  const { loginCredintials } = useContext(ContextAPI);
  const isCEO = loginCredintials?.role === 'CEO';

  // Existing states
  const [rampCount, setRampCount] = useState();
  const [rampData, setRampData] = useState([]);
  const [openMechanicModal, setOpenMechanicModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedRamp, setSelectedRamp] = useState({});
  const [partRows, setPartRows] = useState([]);
  const [jobSelected, setJobSelected] = useState();

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [editable, setEditable] = useState(false);
  const [dataSource, setData] = useState([]);

  const [redirect, setRedirect] = useState(false);
  const [selected, setSelected] = useState(null);
  const [spinning, setSpinning] = useState(false);

  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  // New states for material issue functionality
  const [itemList, setItemList] = useState([]);
  const [partsData, setPartsData] = useState([]);
  const [selectItemObj, setSelectItemObj] = useState({});
  const [mechanic, setMechanic] = useState([]);
  const [mechanics, setMechanics] = useState();
  const [jobNo, setJobNo] = useState([]);
  const [grandTtl, setGrandTotal] = useState(0);
  const [currentSlipNo, setCurrentSlipNo] = useState(1);
  const [quantityValidation, setQuantityValidation] = useState({});
  const [spareInventory, setSpareInventory] = useState({});
  const [initialPartDetails, setInitialPartDetails] = useState({});
  const [loadingJobMaterials, setLoadingJobMaterials] = useState(false);
  const [existingMaterialIssueId, setExistingMaterialIssueId] = useState(null);
  const [mcid, setMcid] = useState("");
  const [branch, setBranch] = useState("");
  const [deletedRowIds, setDeletedRowIds] = useState([]);
  const [deletedPartData, setDeletedPartData] = useState([]);
  const [slipNumberFetched, setSlipNumberFetched] = useState(false);

  const issueTypes = [
    { key: "Foc", title: "FOC" },
    { key: "Paid", title: "PAID" },
    { key: "warranty", title: "WARRANTY" },
  ];

  const partItemData = {
    id: getUUID(),
    partNumber: {},
    issueType: "PAID",
    mechanic: selectedRamp?.mechanic?.id || "",
    issueDate: moment(Date.now()),
    quantity: 1,
    mrp: "",
    slipNumber: null,
    grandTotal: 0,
    remove: "",
  };

  const menu = (
    <Menu>
      <Item onClick={() => setLimit(5)} key="1">
        5
      </Item>
      <Item onClick={() => setLimit(10)} key="2">
        10
      </Item>
      <Item onClick={() => setLimit(15)} key="3">
        15
      </Item>
      <Item onClick={() => setLimit(20)} key="4">
        20
      </Item>
    </Menu>
  );

  useEffect(() => {
    getRampDetails();
    initializeAccess();
    setPrimaryData(search);

    // Initialize material issue data
    setItemList([partItemData]);

    // Fetch initial data
    platformApi.get("/api/user/currentUser").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          const userBranch = response.data.profile.branch[0].id;
          setBranch(userBranch);
          fetchSpareInventory(userBranch);
        }
      }
    });
  }, []);

  const fetchSpareInventory = (branchId, jobCardId) => {
    if (!branchId) return;
    const payload = { branch: branchId };
    const activeJobCardId = jobCardId || jobSelected;
    if (activeJobCardId) {
      payload.jobCardId = activeJobCardId;
    }
    platformApi.post("/api/sparesInventory/getAllByBranch", payload).then((res) => {
      const spareObject = {};
      if (res.data && res.data.response && Array.isArray(res.data.response.data)) {
        for (const spare of res.data.response.data) {
          if (spare && spare.partNo) {
            const partNumber = spare.partNo.partNumber;
            spareObject[partNumber] = spare;
          }
        }
      }
      setSpareInventory(spareObject);
    });
  };

  useEffect(() => {
    // Always use the job card's branch for inventory — NOT the ramp's physical branch
    const activeBranchId = selectedRamp?.job?.branch?.id || branch;
    if (activeBranchId) {
      fetchSpareInventory(activeBranchId, selectedRamp?.job?.id || jobSelected);
    }
  }, [selectedRamp, branch, jobSelected]);

  const debouncedSearchParts = useMemo(
    () => debounce(async (searchString) => {
      if (searchString.length < 2) return; // Don't search for very short strings

      try {
        const res = await platformApi.post("/api/options/get/", {
          module: "sparesInventories",
          column: "partNumber",
          searchString: searchString,
          searchColumns: ["partNumber", "partName"],
          size: 100,
          page: 1,
          except: null,
          branch: selectedRamp?.job?.branch?.id || branch,
        });

        let parts = [];
        if (Array.isArray(res.data.response)) {
          for (let i = 0; i < res.data.response.length; i++) {
            const element = res.data.response[i];
            if (element && element.partNo) {
              parts.push(element.partNo);
            }
          }
        }

        setPartsData(parts);
      } catch (error) {
        console.error("Error searching parts:", error);
      }
    }, 300), // 300ms delay
    [branch, selectedRamp]
  );

  const initializeAccess = () => {
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "material_issue") {
          if (each.access.create) setCreateAccess(true);
          if (each.access.update) setModifyAccess(true);
          if (each.access.delete) setDeleteAccess(true);
        }
      });
  };

  const getRampDetails = async () => {
    try {
      const res = await platformApi.get(`/api/ramp`);
      const data = res.data?.response;
      if (Array.isArray(data)) {
        setRampData(data);
        const total = data.reduce((sum, g) => sum + (g.total || 0), 0);
        setRampCount(total);
      } else if (data) {
        setRampCount(data?.total);
        setRampData([
          { branchId: null, total: data?.total || 0, ramps: data?.ramps || [] },
        ]);
      }
    } catch (err) {
      console.error("Error fetching ramps:", err);
      message.error("Unable to fetch ramps");
    }
  };

  const handleClearRamp = (rampNo) => {
    platformApi
      .delete(`/api/ramp/${rampNo}`)
      .then(() => {
        message.success("Ramp cleared");
        if (open) setOpen(false);
        getRampDetails();
      })
      .catch((e) => {
        console.error(e);
        message.error("Failed to clear ramp");
      });
  };

  const handleRemoveMechanic = (rampId) => {
    platformApi
      .post("/api/ramp/removeMechanic", { rampId })
      .then((res) => {
        if (res.data?.code === 200) {
          message.success("Mechanic unassigned from ramp");
          if (selectedRamp?.id === rampId || open) {
            setOpen(false);
            setSelectedRamp({});
            setJobSelected(null);
            setItemList([{ ...partItemData, id: getUUID() }]);
            setExistingMaterialIssueId(null);
            setInitialPartDetails({});
          }
          getRampDetails();
        } else {
          message.error("Failed to unassign mechanic");
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Failed to unassign mechanic");
      });
  };

  useEffect(() => {
    setPrimaryData(search);
  }, [page, limit, search]);

  const setPrimaryData = (search, val) => {
    setSpinning(true);
    platformApi
      .post("/api/materialIssue/get", {
        page: val ? val : page,
        size: limit,
        searchString: search,
        type: "parts_issue",
      })
      .then((res) => {
        setSpinning(false);
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setData(response.data.materialIssue);
            setCount(response.data.count);
          } else {
            message.error("Unable to fetch MaterialIssues", 2);
          }
        } else {
          message.error("Unable to fetch MaterialIssues", 2);
        }
      })
      .catch((err) => {
        setSpinning(false);
        console.error("Error on MaterilIssue : ", err);
        message.error("Unable to fetch MaterialaIssue", 2);
      });
  };

  useEffect(() => {
    if (jobSelected) {
      fetchJobMaterials(jobSelected);
    }
  }, [jobSelected]);

  useEffect(() => {
    const selectItem = {};
    for (const item of itemList) {
      if (item.partNumber && item.partNumber.id) {
        selectItem[item.partNumber.id] = true;
      }
    }
    setSelectItemObj(selectItem);
  }, [itemList]);

  useEffect(() => {
    if (open) getMechanics();
  }, [open]);

  const getMechanics = () => {
    return platformApi
      .get("/api/user")
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let list = data.data.users.filter((item) => {
            return (
              item.profile &&
              item.profile.department.role === "Mechanic" &&
              item.status === true
            );
          });
          setMechanics(list);
        }
      })
      .catch((err) => {
        console.error("Error getting mechanic", err);
      });
  };

  const fetchJobMaterials = async (jobId) => {
    if (!jobId) return;
    setLoadingJobMaterials(true);
    try {
      const res = await platformApi.get(
        `/api/materialIssue/jobMaterial/${jobId}`
      );
      const { data } = res;

      if (data?.code === 200 && data?.response?.code === 200) {
        const mi = data.response.data;
        setExistingMaterialIssueId(mi[0]?.id || null);

        if (mi?.length) {
          let data = mi?.flatMap((obj) => obj?.parts || []);
          setGrandTotal(mi?.reduce((acc, obj) => acc + obj?.netAmount, 0));
          const restructuredData = data?.map((item) => ({
            id: item?.id,
            partNumber: {
              id: item?.part?.id,
              partNumber: item?.part?.partNumber,
              partName: item?.part?.partName,
            },
            issueType: item?.issueType,
            mechanic: item?.mechanic?.id,
            mechanicName: item?.mechanic?.profile?.employeeName,
            issueDate: item?.issueDate,
            quantity: item?.quantity ?? 0,
            mrp: item?.mrp,
            slipNumber: item?.slipNumber,
            grandTotal: 0,
            remove: "",
          }));

          const initialQtyMap = {};
          data?.forEach((item) => {
            if (item?.part?.partNumber) {
              initialQtyMap[item.part.partNumber] = item.quantity || 0;
            }
          });
          setInitialPartDetails(initialQtyMap);

          const dataWithEmptyRow = [
            ...restructuredData,
            { ...partItemData, id: getUUID() },
          ];
          setItemList(dataWithEmptyRow);
        } else {
          setItemList([{ ...partItemData, id: getUUID() }]);
          setInitialPartDetails({});
          setGrandTotal(0);
        }
      } else {
        setExistingMaterialIssueId(null);
        setItemList([{ ...partItemData, id: getUUID() }]);
        setGrandTotal(0);
      }
    } catch (e) {
      console.error("Error fetching job materials:", e);
      setExistingMaterialIssueId(null);
      setItemList([{ ...partItemData, id: getUUID() }]);
      setGrandTotal(0);
    } finally {
      setLoadingJobMaterials(false);
    }
  };

  const searchMechanic = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 100,
        page: 1,
        except: null,
      })
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let mechanic = data.response.filter((item) => {
            return (
              item.profile &&
              item.profile.department.role === "Mechanic" &&
              item.status === true
            );
          });
          search.setValue(mechanic);
        }
      });
  };

  const searchParts = async (search) => {
    try {
      const res = await platformApi.post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        searchColumns: search.searchColumns,
        size: 100,
        page: 1,
        except: null,
        branch: selectedRamp?.job?.branch?.id || branch,
      });

      let parts = [];
      for (let i = 0; i < res.data.response?.length; i++) {
        const element = res.data.response[i];
        parts.push(element.partNo);
      }

      // Use functional update to ensure state is set properly
      setPartsData(prevParts => {
        return parts;
      });

      return parts;
    } catch (error) {
      console.error("Error searching parts:", error);
      return [];
    }
  };

  const handleDelete = (selectedId) => {
    let toDeleteRow;
    const updatedDataSource = itemList.filter((item) => {
      if (item.id === selectedId) toDeleteRow = item;
      return item.id !== selectedId;
    });

    const lastRow = updatedDataSource[updatedDataSource.length - 1];
    const isLastRowEmpty =
      !lastRow ||
      !lastRow.partNumber ||
      !lastRow.partNumber.partNumber ||
      !lastRow.quantity;

    if (updatedDataSource.length === 0 || !isLastRowEmpty) {
      updatedDataSource.push({ ...partItemData, id: getUUID() });
    }

    // Recalculate totals
    let grandTotal = 0;
    for (let i = 0; i < updatedDataSource.length; i++) {
      if (
        updatedDataSource[i].mrp > 0 &&
        parseFloat(updatedDataSource[i].quantity) > 0
      ) {
        let total = (
          parseFloat(updatedDataSource[i].quantity) *
          parseFloat(updatedDataSource[i].mrp)
        ).toFixed(2);
        updatedDataSource[i].grandTotal = parseFloat(total);
      }
    }
    for (let i = 0; i < updatedDataSource.length; i++) {
      grandTotal =
        parseFloat(grandTotal) +
        parseFloat(updatedDataSource[i].grandTotal || 0);
      grandTotal = grandTotal.toFixed(2);
    }

    // Update state
    setItemList(updatedDataSource);
    setGrandTotal(grandTotal);

    // Prepare delete data for immediate API call
    if (toDeleteRow && toDeleteRow.id) {
      // Call autosave with delete data immediately
      autoSaveWithDelete(toDeleteRow);
    } else {
      // If no valid row to delete, just call regular autosave
      setTimeout(() => autoSave(), 100);
    }
  };

  const autoSaveWithDelete = (deletedRow) => {
    if (!jobSelected) return;

    const filteredItems = itemList
      .filter((item) => item.id !== deletedRow.id) // Exclude the deleted item
      .filter(
        (item) =>
          item.partNumber &&
          item.partNumber.partNumber &&
          item.quantity &&
          parseFloat(item.quantity) > 0
      );

    // Prepare delete payload
    const deleteData = [deletedRow.id]; // Array with the deleted row ID
    const deletePartData = [];

    // If the deleted row has a part, add it to deletePartData
    if (deletedRow.partNumber && deletedRow.partNumber.id) {
      deletePartData.push({
        id: deletedRow.partNumber.id,
        partNumber: { id: deletedRow.partNumber.id },
        quantity: deletedRow.quantity || 0,
      });
    }

    const data = {
      id: existingMaterialIssueId,
      jobOrder: jobSelected,
      currentDate: moment(Date.now()),
      mechanic: mcid,
      materialItemInvoice: filteredItems.map((item) => ({
        ...item,
        mechanic: { id: item?.mechanic },
        quantity: parseFloat(item.quantity),
        mrp: parseFloat(item.mrp),
        grandTotal: parseFloat(item.quantity) * parseFloat(item.mrp),
        slipNumber:
          typeof item.slipNumber === "number"
            ? item.slipNumber
            : item.slipNumber
              ? parseInt(item.slipNumber, 10)
              : null,
      })),
      slipNumber: currentSlipNo + 1,
      netAmount: filteredItems.reduce(
        (sum, item) => sum + parseFloat(item.quantity) * parseFloat(item.mrp),
        0
      ),
      // Always use the job card's branch — this determines which branch inventory is deducted from
      branch: selectedRamp?.job?.branch?.id || branch,
      deleteData: deleteData, // Send the deleted row ID
      deletePartData: deletePartData, // Send the deleted part data
    };

    // Call the API with delete data
    autoSaveDataWithDelete(data);
  };

  const autoSaveDataWithDelete = (materialIssue) => {
    if (materialIssue.id) {
      platformApi
        .put(`/api/materialIssue/${materialIssue.id}`, materialIssue)
        .then((result) => {
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              // Update local dataSource safely
              if (response.data) {
                const updatedList = dataSource.map((obj) => (obj && materialIssue.id === obj.id ? response.data : obj)).filter(Boolean);
                setData(updatedList);
              } else {
                setData(dataSource.filter((obj) => obj && obj.id !== materialIssue.id));
              }
              getRampDetails();

              // Sync table rows from response
              setLoadingJobMaterials(true);
              const updatedMi = response.data;
              if (updatedMi) {
                const restructuredData = (updatedMi.parts || []).map(
                  (item) => ({
                    id: item?.id,
                    partNumber: {
                      id: item?.part?.id,
                      partNumber: item?.part?.partNumber,
                      partName: item?.part?.partName,
                    },
                    issueType: item?.issueType,
                    mechanic: item?.mechanic?.id,
                    mechanicName: item?.mechanic?.profile?.employeeName,
                    issueDate: item?.issueDate,
                    quantity: item?.quantity,
                    mrp: item?.mrp,
                    slipNumber: item?.slipNumber ?? null,
                    grandTotal: 0,
                    remove: "",
                  })
                );

                const initialQtyMap = {};
                (updatedMi.parts || []).forEach((item) => {
                  if (item?.part?.partNumber) {
                    initialQtyMap[item.part.partNumber] = item.quantity || 0;
                  }
                });
                setInitialPartDetails(initialQtyMap);

                const dataWithEmptyRow = [
                  ...restructuredData,
                  { ...partItemData, id: getUUID() },
                ];
                setItemList(dataWithEmptyRow);
                if (updatedMi.id) setExistingMaterialIssueId(updatedMi.id);
                const total = restructuredData.reduce(
                  (sum, r) =>
                    sum + (parseFloat(r.quantity) * parseFloat(r.mrp) || 0),
                  0
                );
                setGrandTotal(total.toFixed(2));
              } else {
                setInitialPartDetails({});
                setExistingMaterialIssueId(null);
                setItemList([{ ...partItemData, id: getUUID() }]);
                setGrandTotal(0);
              }
              setLoadingJobMaterials(false);
              if (materialIssue.branch) {
                fetchSpareInventory(materialIssue.branch);
              }
            }
          }
        })
        .catch((error) => {
          console.error("Delete autosave error:", error);
          const errMsg = error?.response?.data?.message || error?.data?.message || error?.message || "Failed to delete item";
          message.warning(errMsg, 4);
        });
    }
  };

  const createEmptyPartItem = () => ({
    id: getUUID(),
    partNumber: {},
    issueType: "PAID",
    mechanic: "",
    issueDate: moment(Date.now()),
    quantity: "",
    mrp: "",
    slipNumber: null,
    grandTotal: 0,
    remove: "",
  });

  useEffect(() => {
    getRampDetails();
    initializeAccess();
    setPrimaryData(search);
    setItemList([createEmptyPartItem()]);
  }, []);

  // Update the part where you handle ramp click and job selection
  const handleRampClick = (ramp) => {
    if (selectedRamp?.id === ramp.id && open) {
      setSelectedRamp({});
      setOpen(false);
      setItemList([createEmptyPartItem()]); // Reset with fresh empty item
      setGrandTotal(0);
    } else {
      setSelectedRamp(ramp);
      setOpen(true);
      if (ramp.job) {
        setJobSelected(ramp.job.id);
        setMcid(ramp.mechanic?.id || "");
      } else {
        // No job, reset to empty state
        setItemList([createEmptyPartItem()]);
        setJobSelected(null);
        setGrandTotal(0);
      }
    }
  };

  const handleQuantity = (event, record) => {
    const partNumber = record.partNumber?.partNumber;
    let value = parseFloat(event.target.value) || 0;

    if (partNumber) {
      const inv = spareInventory[partNumber];
      const availableQty = inv != null ? (inv.availableForJob !== undefined ? inv.availableForJob : inv.phyQuantity) : 0;
      const prevQty = initialPartDetails[partNumber] || 0;
      const maxQty = availableQty + prevQty;
      if (value > maxQty) {
        value = maxQty;
        message.warning(`Maximum available quantity for this part is ${maxQty}`, 2);
      }
    }

    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.quantity = value;
        break;
      }
    }
    setItemList(newItemList);

    // Calculate new total
    let grandTotal = 0;
    for (let i = 0; i < newItemList.length; i++) {
      if (newItemList[i].mrp > 0 && parseFloat(newItemList[i].quantity) > 0) {
        let total = (
          parseFloat(newItemList[i].quantity) * parseFloat(newItemList[i].mrp)
        ).toFixed(2);
        newItemList[i].grandTotal = parseFloat(total);
        grandTotal = parseFloat(grandTotal) + parseFloat(total);
      }
    }
    setGrandTotal(grandTotal.toFixed(2));

    //setTimeout(() => autoSave(), 100);
  };
  const handleQuantitySave = (event, record) => {
    const partNumber = record.partNumber?.partNumber;
    let value = parseFloat(event.target.value) || 0;

    // Cap the quantity to free stock = availableForJob + prevQty
    if (partNumber) {
      const inv = spareInventory[partNumber];
      const availableQty = inv != null ? (inv.availableForJob !== undefined ? inv.availableForJob : inv.phyQuantity) : 0;
      const prevQty = initialPartDetails[partNumber] || 0;
      const maxQty = availableQty + prevQty;
      if (value > maxQty) {
        value = maxQty;
        message.warning(`Maximum available quantity for this part is ${maxQty}`, 2);
      }
    }

    let updatedList = [...itemList];

    for (let item of updatedList) {
      if (item.id === record.id) {
        item.quantity = value;
        item.grandTotal = parseFloat((value * parseFloat(item.mrp || 0)).toFixed(2));
        break;
      }
    }

    setItemList(updatedList);

    const grandTotal = updatedList.reduce((sum, item) => {
      if (item.mrp > 0 && parseFloat(item.quantity) > 0) {
        return sum + item.quantity * item.mrp;
      }
      return sum;
    }, 0);

    setGrandTotal(grandTotal.toFixed(2));
    autoSave();
  };


  const handleMRP = (event, record) => {
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.mrp = event.target.value;
        break;
      }
    }
    setItemList(newItemList);

    let grandTotal = 0;
    for (let i = 0; i < newItemList.length; i++) {
      if (newItemList[i].mrp > 0 && parseFloat(newItemList[i].quantity) > 0) {
        let total = (
          parseFloat(newItemList[i].quantity) * parseFloat(newItemList[i].mrp)
        ).toFixed(2);
        newItemList[i].grandTotal = parseFloat(total);
        grandTotal = parseFloat(grandTotal) + parseFloat(total);
      }
    }
    setGrandTotal(grandTotal.toFixed(2));

    setTimeout(() => autoSave(), 100);
  };

  const handleTypeChange = (event, data) => {
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === data.id) {
        item.issueType = event;
        break;
      }
    }
    setItemList(newItemList);

    setTimeout(() => autoSave(), 100);
  };

  const handleMechanicTable = (event, data) => {
    setItemList((prevItemList) =>
      prevItemList.map((item) =>
        item.id === data.id
          ? {
            ...item,
            mechanic: event,
            slipNumber: item.slipNumber || currentSlipNo,
          }
          : item
      )
    );
    setTimeout(() => autoSave(), 100);
  };

  const handlePartDetail = async (event, data) => {
    const newItemList = [...itemList];
    let nextSlipNo = currentSlipNo;
    if (event !== undefined) {
      let isInvalidPart = false;
      partsData.forEach((part) => {
        if (part.id === event) {
          const inv = spareInventory[part.partNumber];
          if (inv) {
            const phyQty = inv.phyQuantity || 0;
            if (phyQty <= 0) {
              isInvalidPart = true;
              message.warning(`Warning: Part ${part.partNumber} has 0 physical quantity in stock.`, 3);
              return;
            }
          }
          newItemList.forEach((item) => {
            if (item.id === data.id) {
              item.partNumber = part;
              item.mrp = part.mrp;
              item.quantity = 1;
              item.slipNumber = nextSlipNo;
            }
          });
        }
      });

      if (isInvalidPart) {
        setItemList(prev => prev.map(item => item.id === data.id ? { ...partItemData, id: data.id } : item));
        return;
      }

      // Check if last row is filled
      const isLastRowFilled =
        newItemList[newItemList.length - 1].partNumber &&
        newItemList[newItemList.length - 1].partNumber.partNumber;

      if (isLastRowFilled) {
        if (!slipNumberFetched) {
          try {
            if (existingMaterialIssueId) {
              const res = await platformApi.get(
                `/api/materialIssue/maxSlipNumber/${existingMaterialIssueId}`
              );
              if (res?.data?.code === 200) {
                nextSlipNo = res.data.response.nextSlipNumber;
                newItemList.forEach((item) => {
                  if (item.id === data.id) {
                    item.slipNumber = nextSlipNo;
                  }
                });
                setCurrentSlipNo(nextSlipNo);

              } else {
                setCurrentSlipNo(1);
              }
            } else {
              setCurrentSlipNo(1);
            }
          } catch (err) {
            console.error("Error fetching slip number:", err);
            setCurrentSlipNo(1);
          }
          setSlipNumberFetched(true);
        }
        // Add a new empty row
        newItemList.push({
          ...partItemData,
          id: getUUID(),
          slipNumber: null,
        });
      }
    }

    setItemList(newItemList);

    let grandTotal = 0;
    newItemList.forEach((item) => {
      if (item.mrp > 0 && parseFloat(item.quantity) > 0) {
        const total = parseFloat(item.quantity) * parseFloat(item.mrp);
        item.grandTotal = total;
        grandTotal += total;
      }
    });
    setGrandTotal(grandTotal.toFixed(2));

    setTimeout(() => autoSave(nextSlipNo), 100);
  };

  const autoSave = (slipNo, deleteRowId = null, deletePartData = null) => {
    if (!jobSelected) return;

    const filteredItems = itemList.filter(
      (item) =>
        item.partNumber &&
        item.partNumber.partNumber &&
        item.quantity !== null && // allow 0 also
        item.quantity !== undefined
    );

    if (filteredItems.length === 0 && !deleteRowId) return;
    const data = {
      id: existingMaterialIssueId,
      jobOrder: jobSelected,
      currentDate: moment(Date.now()),
      mechanic: mcid || (filteredItems[0]?.mechanic || null),
      materialItemInvoice: filteredItems.map((item) => ({
        ...item,
        mechanic: item.mechanic ? { id: item.mechanic } : null,
        quantity: parseFloat(item.quantity) || 0,
        mrp: parseFloat(item.mrp),
        grandTotal: parseFloat(item.quantity) * parseFloat(item.mrp),
        slipNumber: item.slipNumber,
      })),
      slipNumber: currentSlipNo,
      netAmount: filteredItems.reduce(
        (sum, item) => sum + parseFloat(item.quantity) * parseFloat(item.mrp),
        0
      ),
      branch: selectedRamp?.job?.branch?.id || branch,
      // Include delete data if provided
      ...(deleteRowId && { deleteData: [deleteRowId] }),
      ...(deletePartData && { deletePartData: [deletePartData] }),
    };

    autoSaveData(data);
  };

  const autoSaveData = (materialIssue) => {
    if (materialIssue.id) {
      platformApi
        .put(`/api/materialIssue/${materialIssue.id}`, materialIssue)
        .then((result) => {
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              if (response.data) {
                const updatedList = dataSource.map((obj) => (obj && materialIssue.id === obj.id ? response.data : obj)).filter(Boolean);
                setData(updatedList);
              } else {
                setData(dataSource.filter((obj) => obj && obj.id !== materialIssue.id));
              }
              getRampDetails();
              // Sync table rows from single-object response
              setLoadingJobMaterials(true);
              const updatedMi = response.data;
              if (updatedMi) {
                const restructuredData = (updatedMi.parts || []).map(
                  (item) => {
                    if (!item || !item.part) return null;
                    return {
                      id: item.id,
                      partNumber: {
                        id: item.part.id,
                        partNumber: item.part.partNumber,
                        partName: item.part.partName,
                      },
                      issueType: item.issueType,
                      mechanic: item.mechanic?.id,
                      mechanicName: item.mechanic?.profile?.employeeName,
                      issueDate: item.issueDate,
                      quantity: item.quantity,
                      mrp: item.mrp,
                      slipNumber: item.slipNumber ?? materialIssue.slipNumber,
                      grandTotal: 0,
                      remove: "",
                    };
                  }
                ).filter(Boolean);

                const initialQtyMap = {};
                (updatedMi.parts || []).forEach((item) => {
                  if (item?.part?.partNumber) {
                    initialQtyMap[item.part.partNumber] = item.quantity || 0;
                  }
                });
                setInitialPartDetails(initialQtyMap);

                const dataWithEmptyRow = [
                  ...restructuredData,
                  { ...partItemData, id: getUUID(), slipNumber: null },
                ];
                setItemList(dataWithEmptyRow);
                if (updatedMi.id) setExistingMaterialIssueId(updatedMi.id);
                const total = restructuredData.reduce(
                  (sum, r) =>
                    sum + (parseFloat(r.quantity) * parseFloat(r.mrp) || 0),
                  0
                );
                setGrandTotal(total.toFixed(2));
              } else {
                setInitialPartDetails({});
                setExistingMaterialIssueId(null);
                setItemList([{ ...partItemData, id: getUUID() }]);
                setGrandTotal(0);
              }
              setLoadingJobMaterials(false);
              if (materialIssue.branch) {
                fetchSpareInventory(materialIssue.branch);
              }
              // Clear deletion trackers on success
              setDeletedRowIds([]);
              setDeletedPartData([]);
            } else {
              message.warning(response?.message || data.msg || "Cannot issue reserved parts.", 4);
              if (jobSelected) fetchJobMaterials(jobSelected);
            }
          } else {
            message.warning(data.message || data.msg || "Cannot issue reserved parts.", 4);
            if (jobSelected) fetchJobMaterials(jobSelected);
          }
        })
        .catch((error) => {
          console.error("Autosave error:", error);
          const errMsg = error?.response?.data?.message || error?.data?.message || error?.message || "Cannot issue reserved parts.";
          message.warning(errMsg, 4);
          if (jobSelected) fetchJobMaterials(jobSelected);
        });
    } else {
      platformApi
        .post("/api/materialIssue", materialIssue)
        .then((result) => {
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setData([...dataSource, response.data]);
              setCount(count + 1);
              getRampDetails();
              // Sync table rows from single-object response
              setLoadingJobMaterials(true);
              const createdMi = response.data;
              if (createdMi) {
                const restructuredData = (createdMi.parts || []).map(
                  (item) => {
                    if (!item || !item.part) return null;
                    return {
                      id: item.id,
                      partNumber: {
                        id: item.part.id,
                        partNumber: item.part.partNumber,
                        partName: item.part.partName,
                      },
                      issueType: item.issueType,
                      mechanic: item.mechanic?.id,
                      mechanicName: item.mechanic?.profile?.employeeName,
                      issueDate: item.issueDate,
                      quantity: item.quantity,
                      mrp: item.part?.mrp,
                      slipNumber: item.slipNumber ?? materialIssue.slipNumber,
                      grandTotal: 0,
                      remove: "",
                    };
                  }
                ).filter(Boolean);

                const initialQtyMap = {};
                (createdMi.parts || []).forEach((item) => {
                  if (item?.part?.partNumber) {
                    initialQtyMap[item.part.partNumber] = item.quantity || 0;
                  }
                });
                setInitialPartDetails(initialQtyMap);
                const dataWithEmptyRow = [
                  ...restructuredData,
                  { ...partItemData, id: getUUID(), slipNumber: null },
                ];
                setItemList(dataWithEmptyRow);
                if (createdMi.id) setExistingMaterialIssueId(createdMi.id);
                const total = restructuredData.reduce(
                  (sum, r) =>
                    sum + (parseFloat(r.quantity) * parseFloat(r.mrp) || 0),
                  0
                );
                setGrandTotal(total.toFixed(2));
              } else {
                setInitialPartDetails({});
                setExistingMaterialIssueId(null);
                setItemList([{ ...partItemData, id: getUUID() }]);
                setGrandTotal(0);
              }
              setLoadingJobMaterials(false);
              if (materialIssue.branch) {
                fetchSpareInventory(materialIssue.branch);
              }
              // Clear deletion trackers on success
              setDeletedRowIds([]);
              setDeletedPartData([]);
            } else {
              message.warning(response?.message || data.msg || "Cannot issue reserved parts.", 4);
              if (jobSelected) fetchJobMaterials(jobSelected);
            }
          } else {
            message.warning(data.message || data.msg || "Cannot issue reserved parts.", 4);
            if (jobSelected) fetchJobMaterials(jobSelected);
          }
        })
        .catch((error) => {
          console.error("Autosave error:", error);
          const errMsg = error?.response?.data?.message || error?.data?.message || error?.message || "Cannot issue reserved parts.";
          message.warning(errMsg, 4);
          if (jobSelected) fetchJobMaterials(jobSelected);
        });
    }
  };

  const renderColumns = () => {
    const columns = [
      {
        title: "S.No",
        dataIndex: "sno",
        key: "sno",
        width: 70,
        render: (text, record, index) => index + 1,
      },
      {
        title: "Part Number",
        dataIndex: "partNumber",
        key: "partNumber",
        width: 360,
        render: (record, data, index) => (
          <Select
            key={`part-select-${data.id}`} // Add key to force re-render when needed
            dropdownStyle={{
              overflowY: "auto",
              overflowX: "hidden",
            }}
            onFocus={() => {
              if (data.partNumber) {
                setQuantityValidation((prev) => ({
                  ...prev,
                  [data.partNumber.partNumber]: false,
                }));
              }

              searchParts({
                module: "sparesInventories",
                column: "partNumber",
                searchString: "",
                searchColumns: ["partNumber", "partName"],
                setValue: setPartsData,
              });
            }}
            onChange={(event) => {
              handlePartDetail(event, data);
            }}
            onSearch={(searchText) => {
              if (searchText && searchText.length >= 2) {
                debouncedSearchParts(searchText);
              } else if (searchText === "") {
                searchParts({
                  module: "sparesInventories",
                  column: "partNumber",
                  searchString: "",
                  searchColumns: ["partNumber", "partName"],
                  setValue: setPartsData,
                });
              }
            }}
            value={
              record?.partNumber
                ? `${record.partNumber} - ${record.partName}`
                : undefined
            }
            showSearch
            placeholder="Part Number"
            filterOption={false}
            notFoundContent={partsData.length === 0 ? "No parts found" : null}
          >
            {partsData.map((part) => {
              if (!part || (part.id in selectItemObj && part.id !== data.partNumber?.id)) return null;
              return (
                <Option key={`${part.id}-${part.partNumber}`} value={part.id}>
                  {part.partNumber} - {part.partName}
                </Option>
              );
            })}
          </Select>
        ),
      },
      {
        title: "Issue Type",
        dataIndex: "issueType",
        key: "issueType",
        width: 110,
        render: (data, record) => (
          <Select
            onChange={(event) => {
              handleTypeChange(event, record);
            }}
            value={record.issueType || "PAID"}
          >
            {issueTypes.map((issue) => (
              <Option key={issue.key} value={issue.title}>
                {issue.title}
              </Option>
            ))}
          </Select>
        ),
      },
      {
        title: "Issue Date",
        dataIndex: "issueDate",
        key: "issueDate",
        width: 100,
        render: (record) => (
          <span>
            {record
              ? moment(record).format("DD-MM-YYYY")
              : moment(Date.now()).format("DD/MM/YYYY")}
          </span>
        ),
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 100,
        render: (data, record, index) => {
          const partNumber = record.partNumber?.partNumber;
          let maxQty = null;
          if (partNumber) {
            const inv = spareInventory[partNumber];
            const availableQty = inv != null ? (inv.availableForJob !== undefined ? inv.availableForJob : inv.phyQuantity) : 0;
            const prevQty = initialPartDetails[partNumber] || 0;
            maxQty = availableQty + prevQty;
          }
          return (
            <Input
              type="text"
              onChange={(event) => {
                const value = event.target.value.replace(/[^0-9]/g, ""); // only digits
                handleQuantity({ target: { value } }, record);
              }}
              onBlur={(event) => {
                handleQuantitySave(event, record);
              }}
              onPressEnter={(event) => {
                handleQuantitySave(event, record);
              }}
              placeholder="Qty"
              value={record.quantity ?? ""}
              addonAfter={
                maxQty != null
                  ? <span style={{ color: '#888', fontSize: 12 }}>/{maxQty}</span>
                  : null
              }
            />
          );
        },
      },
      {
        title: "Slip No",
        dataIndex: "slipNumber",
        key: "slipNumber",
        width: 75,
        render: (data, record) => (
          <span>{record.slipNumber ?? ""}</span>
        ),
      },
      {
        title: "MRP",
        dataIndex: "mrp",
        key: "mrp",
        width: 90,
        render: (data, record, index) => (
          <Input
            onChange={(event) => {
              const value = event.target.value.replace(/[^0-9.]/g, ""); // digits and dot
              // Ensure only one dot
              const parts = value.split(".");
              const cleanedValue = parts[0] + (parts.length > 1 ? "." + parts[1] : "");
              handleMRP({ target: { value: cleanedValue } }, record);
            }}
            placeholder="MRP"
            value={record.mrp}
          />
        ),
      },
      {
        title: "Total",
        dataIndex: "grandTotal",
        key: "grandTotal",
        width: 110,
        render: (data, record) => (
          <span>{(record.quantity * record.mrp || 0).toFixed(2)}</span>
        ),
      },
      {
        title: "Action",
        dataIndex: "remove",
        key: "x",
        width: 80,
        render: (data, record) => {
          // Only show delete for filled rows, and only if there's more than one row
          const filledRows = itemList.filter(
            (item) =>
              item.partNumber && item.partNumber.partNumber && item.quantity !== null &&
              item.quantity !== undefined
          );
          const isFilledRow =
            record.partNumber &&
            record.partNumber.partNumber &&
            record.quantity !== null &&
            record.quantity !== undefined;

          return isFilledRow &&
            (filledRows.length > 0 || itemList.length > 1) ? (
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => {
                handleDelete(record.id);
              }}
            >
              <a style={{ color: "#6c7b8a" }}>Delete</a>
            </Popconfirm>
          ) : null;
        },
      },
    ];
    return columns;
  };

  const deleteData = (id) => {
    setSpinning(true);
    let temp = page != 1 && dataSource.length === 1;
    platformApi
      .delete(`/api/materialIssue/${id}`)
      .then((result) => {
        setSpinning(false);
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setData(dataSource.filter((obj) => id !== obj.id));
            message.success("Material Issue deleted successfully", 2);
            if (temp) {
              setPage(1);
              setPrimaryData(null, 1);
            } else {
              setPrimaryData();
            }
          } else {
            message.error("Unable to delete Material Issue", 2);
          }
        } else if (data.code === 201) {
          message.error(
            "Can't delete Material Issue, Sale Invoice Associated",
            2
          );
        } else {
          message.error("Unable to delete Material Issue", 2);
        }
      })
      .catch((error) => {
        message.error("Unable to delete Material Issue", 2);
        console.error("Error on Material Issue : ", error);
      });
  };

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Parts Issue [{count}]
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Parts Issue"
          onSearch={(event) => {
            setPage(1);
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null);
              setPage(1);
            }
          }}
        />
        <Button
          onClick={() => {
            history.push("/autoadmin/material_issue/:id");
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Parts Issue
        </Button>
      </div>
      <div style={{ margin: ".5rem" }}>
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button>
            {limit} &nbsp;
            <Icon type="down" />
          </Button>
        </Dropdown>
      </div>
      <Tabs
        defaultActiveKey="1"
        onChange={(activeKey) => {
          const ramp = rampData.find((r) => r.rampNo?.toString() === activeKey);
          if (ramp) {
            setSelectedRamp(ramp);
          }
          if (activeKey === "2") {
            setPrimaryData();
          }
        }}
      >
        <TabPane tab="Ramps" key="1">
          <>
            {Array.isArray(rampData) &&
              rampData.length > 0 &&
              rampData.map((branchGroup) => {
                const rows = [];
                const ramps = branchGroup.ramps || [];
                for (let i = 0; i < ramps.length; i += 3) {
                  rows.push(ramps?.slice(i, i + 3));
                }
                return rows.map((group, groupIndex) => (
                  <Row
                    key={`${branchGroup.branchId || "branch"
                      }-row-${groupIndex}`}
                    gutter={[16, 16]}
                    align="middle"
                  >
                    {group.map((ramp) => {
                      const hasJob = !!ramp.job;
                      const shadowColor = hasJob
                        ? "rgba(255, 0, 0, 0.5)"
                        : "rgba(0, 255, 0, 0.5)";
                      const isExpanded = selectedRamp?.id === ramp.id && open;

                      return (
                        <Col
                          xs={24}
                          sm={12}
                          md={8}
                          key={ramp.id}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            zIndex: isExpanded ? 10 : 1,
                          }}
                        >
                          <Card
                            bordered={false}
                            style={{
                              boxShadow: `0 4px 12px ${shadowColor}`,
                              borderRadius: "12px",
                              maxWidth: "460px",
                              width: "98%",
                              margin: "0 auto",
                              minHeight: "160px",
                              transition: "all 0.3s ease",
                              position: "relative",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (selectedRamp?.id === ramp.id && open) {
                                setSelectedRamp({});
                                setOpen(false);
                                setItemList([partItemData]);
                                setSlipNumberFetched(false);
                              } else {
                                setSelectedRamp(ramp);
                                setOpen(true);
                                if (ramp.job) {
                                  setJobSelected(ramp.job.id);
                                  setMcid(ramp.mechanic?.id || "");
                                }
                                setSlipNumberFetched(false);
                              }
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Text
                                strong
                                style={{ margin: 0, fontSize: "16px" }}
                              >
                                Ramp {ramp.rampNo}
                              </Text>
                              {ramp.mechanic ? (
                                /* Unified pill: name (opens modal) + × (removes mechanic) */
                                <div
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    border: `1px solid ${ramp.mechanic.status === false ? "#faad14" : "#1677ff"}`,
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    background: ramp.mechanic.status === false ? "#fffbe6" : "#e6f4ff",
                                    fontSize: "13px",
                                    cursor: "default",
                                    userSelect: "none",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {/* Clickable name → opens AssignMechanic modal */}
                                  <span
                                    style={{
                                      padding: "3px 10px",
                                      color: ramp.mechanic.status === false ? "#faad14" : "#1677ff",
                                      cursor: "pointer",
                                      fontWeight: 500,
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenMechanicModal(true);
                                      setSelectedRamp(ramp);
                                    }}
                                  >
                                    {ramp.mechanic?.profile?.employeeName || ramp.mechanic?.profile?.employeeId || ramp.mechanic?.id}
                                    {ramp.mechanic.status === false && (
                                      <span style={{ fontSize: "11px", marginLeft: "4px", opacity: 0.8 }}>(Inactive)</span>
                                    )}
                                  </span>
                                  {/* Divider + × → removes mechanic */}
                                  <Popconfirm
                                    title="Remove mechanic from this ramp?"
                                    okText="Yes, Remove"
                                    cancelText="Cancel"
                                    onConfirm={(e) => {
                                      if (e) e.stopPropagation();
                                      handleRemoveMechanic(ramp.id);
                                    }}
                                    onCancel={(e) => { if (e) e.stopPropagation(); }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "3px 8px",
                                        borderLeft: `1px solid ${ramp.mechanic.status === false ? "#faad14" : "#1677ff"}`,
                                        color: ramp.mechanic.status === false ? "#faad14" : "#1677ff",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                        lineHeight: 1,
                                        fontWeight: "bold",
                                        opacity: 0.8,
                                        transition: "opacity 0.2s",
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.opacity = "1"}
                                      onMouseLeave={(e) => e.currentTarget.style.opacity = "0.8"}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      ✕
                                    </span>
                                  </Popconfirm>
                                </div>
                              ) : (
                                <Button
                                  type="default"
                                  size="small"
                                  style={{
                                    borderRadius: "12px",
                                    borderColor: "#1677ff",
                                    color: "#1677ff",
                                    fontSize: "13px",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenMechanicModal(true);
                                    setSelectedRamp(ramp);
                                  }}
                                >
                                  Assign Mechanic
                                </Button>
                              )}
                            </div>
                            <div style={{ marginTop: 6 }}>
                              <Text style={{ color: "rgba(0,0,0,0.65)" }}>
                                {ramp.branch?.name || ""}
                              </Text>
                            </div>
                            <div
                              style={{
                                marginTop: 12,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Text>
                                {hasJob ? ramp.job.jobNo : "No job assigned"}
                              </Text>
                              {hasJob && (
                                <Button
                                  danger
                                  type="link"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedRamp(ramp);
                                    handleClearRamp(ramp.id);
                                  }}
                                >
                                  Clear Ramp
                                </Button>
                              )}
                            </div>
                            {isExpanded && (
                              <AssignJob
                                selectedRamp={selectedRamp}
                                refreshData={() => getRampDetails()}
                                partsRows={partRows}
                                setPartsRows={setPartRows}
                                setJobSelected={setJobSelected}
                                open={open}
                                setSelectedRamp={setSelectedRamp}
                              />
                            )}
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                ));
              })}
            <Divider />

            {open && selectedRamp?.job && (
              <div>
                <div
                  style={{
                    marginBottom: 16,
                    padding: 16,
                    background: "#f5f5f5",
                    borderRadius: 8,
                  }}
                >
                  <Row gutter={16}>
                    <Col span={6}>
                      <div>
                        <strong>Job No:</strong> {selectedRamp.job.jobNo}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div>
                        <strong>Branch:</strong>{" "}
                        {selectedRamp.job.branch?.name || selectedRamp.branch?.name || "-"}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div>
                        <strong>Mechanic:</strong>{" "}
                        {selectedRamp.mechanic?.profile?.employeeName || "-"}
                      </div>
                    </Col>
                    <Col span={6}>
                      <div>
                        <strong>Total:</strong> ₹{grandTtl}
                      </div>
                    </Col>
                  </Row>
                </div>

                <Table
                  className="parts-invoice-table"
                  childrenColumnName="none"
                  rowKey={(record) => record.id}
                  columns={renderColumns()}
                  dataSource={itemList}
                  loading={loadingJobMaterials}
                  tableLayout="fixed"
                  pagination={false}
                  style={{ marginTop: "1rem", marginBottom: "1rem" }}
                  scroll={{ x: "max-content" }}
                />
              </div>
            )}
          </>
        </TabPane>

        <TabPane tab="Parts Issues" key="2">
          <MaterialIssueTable
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              defaultCurrent: 1,
              current: page,
              total: count,
              showQuickJumper: true,
            }}
            redirectPage={(id, editable) => {
              setSelected(id);
              setRedirect(true);
              setEditable(editable);
            }}
            deleteData={deleteData}
            dataSource={dataSource}
            modify={modifyAccess}
            spinner={{
              spinning,
            }}
            deleteAccess={deleteAccess}
          />
        </TabPane>
      </Tabs>

      {openMechanicModal && (
        <AssignMechanic
          open={openMechanicModal}
          close={() => {
            setOpenMechanicModal(false);
            getRampDetails();
            setSelectedRamp({});
          }}
          selectedRamp={selectedRamp}
          assignedMechanics={rampData.flatMap(ramp => (ramp.ramps || []).map(r => r.mechanic?.id).filter(Boolean))}
        />
      )}
    </div>
  );
}
